import React, { useEffect, useState } from "react";
import "./style.scss";
import SidebarLogo from "../../assets/images/sidebarLogo.png";
import PodcastImg from "../../assets/images/sidebar/podcast.png";
import SubscriptionImg from "../../assets/images/sidebar/subscription.png";
import CmsImg from "../../assets/images/sidebar/cms.png";
import notificationImg from "../../assets/images/sidebar/notification-bing.png";
import TenantImg from "../../assets/images/sidebar/tenant.png";
import DashboardImg from "../../assets/images/sidebar/dashboard.png";
import AdvertisingImg from "../../assets/images/sidebar/advertising.png";
import BrandingImg from "../../assets/images/sidebar/branding.svg";
import { ReactComponent as Logout } from "../../assets/images/Power.svg";
import { ReactComponent as Password } from "../../assets/images/lock.svg";
import { ReactComponent as AboutUs } from "../../assets/images/Infocircle.svg";
import { ReactComponent as PrivacyPolicy } from "../../assets/images/ShieldWarning.svg";
import { ReactComponent as TermsCondition } from "../../assets/images/Document Add.svg";
import { ReactComponent as ViewDetail } from "../../assets/images/User Rounded.svg";
import noteImg from "../../assets/images/sidebar/note.png";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Layout, Menu, Space, theme } from "antd";
import { Link, useLocation, useNavigate } from "react-router";
import ConfirmModal from "../../components/common/alert-popup";
import ChangePasswordModal from "../../modules/auth/change-password/ChangePasswordModal";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../utils/token/token";
import { mySubscription } from "../../redux/action/mySubscription/mySubscription";
import dayjs from "dayjs";
const { Header, Content, Sider } = Layout;


function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
<img src="" alt="" />;

const DashboardView = ({ children = <></> }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const loc = useLocation();
  const [changePassword, setChangePassword] = useState(false);
  const navigate = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState("1");

  const [subsData, setSubsData] = useState(null);
  const dispatch = useDispatch()
  const [subscription, setSubscription] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await dispatch(mySubscription());
      setSubsData(response);
    };

    fetchData();
  }, [dispatch, subscription]);
  const today = dayjs();

  const daysLeft = dayjs(subsData?.subscription_end_date)
              .startOf("day")
              .diff(today?.startOf("day"), "day");

              console.log(daysLeft, "dsmkjfdj")


  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = (actionType) => {
    setModalConfig({ open: false, actionType });
  };
  const isAvdt = useSelector((store) => store.auth?.data?.result?.manage_advt);
  const isAdv = localStorage.getItem("IS_ADV") === "true";

  useEffect(() => {
    switch (loc.pathname.split("/")[1]) {
      case "dashboard":
        setSelectedKeys("1");
        break;
      case "user-management":
        setSelectedKeys("2");
        break;
      case "manage-podcast":
        setSelectedKeys("3");
        break;
      case "branding":
        setSelectedKeys("4");
        break;
      case "my-subscription":
        setSelectedKeys("5");
        break;
      case "advertising":
        setSelectedKeys("6");
        break;
      case "user-activity":
        setSelectedKeys("7");
        break;
      default:
        setSelectedKeys();
        break;
    }
  }, [loc.pathname]);

  const items = [
    getItem(
      <Link onClick={() => setSubscription((prev) => !prev)} to={"/dashboard"}>Dashboard</Link>,
      "1",
      <img src={DashboardImg} alt={DashboardImg} />
    ),
    getItem(
      <Link to={"/user-management"}>User Management</Link>,
      "2",
      <img src={TenantImg} alt={TenantImg} />
    ),
    getItem(
      <Link to={"/user-activity"}>User Activity Log</Link>,
      "7",
      <img src={noteImg} alt={noteImg} />
    ),
    getItem(
      <Link to={"/manage-podcast"}>Podcast Management</Link>,
      "3",
      <img src={PodcastImg} alt={PodcastImg} />
    ),
    getItem(
      <Link to={"/branding"}>Branding</Link>,
      "4",
      <img src={BrandingImg} alt={BrandingImg} />
    ),
    getItem(
    <Link to={"/cms-mgmnt"}>CMS Management</Link>,
    "8",
    <img src={CmsImg} alt={CmsImg} />
  ),
    getItem(
      <Link to={"/my-subscription"}>My Subscription</Link>,
      "5",
      <img src={SubscriptionImg} alt={SubscriptionImg} />
    ),
    isAdv || isAvdt
      ? getItem(
          <Link to={"/advertising"}>Advertising</Link>,
          "6",
          <img src={AdvertisingImg} alt="Advertising" />
        )
      : null,
      getItem(
    <Link to={"/notification"}>Notification</Link>,
    "9",
    <img src={notificationImg} alt="Notification" />
  ),
  ].filter(Boolean);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const handleMenuSelect = ({ key }) => {
    const selectedItem = items
      .flatMap((item) => [item, ...(item.children || [])])
      .find((item) => item.key === key);

    if (selectedItem) {
      setActiveMenu(selectedItem.label);
    }
  };

  const handleMenuClick = ({ key }) => {
    if (key === "changePassword") {
      setChangePassword(true);
    } else if (key === "logout") {
      showModal("logout");
    } else if (key === "about") {
      navigate("about-us");
    } else if (key === "view") {
      navigate("view-profile");
    } else if (key === "terms") {
      navigate("terms-and-conditions");
    } else if (key === "privacy") {
      navigate("privacy-and-policy");
    }
  };

  if (localStorage.getItem("USER_NAME") === "undefined") {
    localStorage.removeItem("USER_NAME");
  }

  if (localStorage.getItem("USER_EMAIL") === "undefined") {
    localStorage.removeItem("USER_EMAIL");
  }
  const userName = localStorage.getItem("USER_NAME") ?? "John Doe";
  const userEmail = localStorage.getItem("USER_EMAIL") ?? "johndoe@example.com";

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="profile" className="userProfileItem" disabled>
        <div className="userInfo">
          <Avatar size={40} icon={<UserOutlined />} />
          <div className="userDetails">
            <p className="userName">{userName}</p>
            <p className="userEmail">{userEmail}</p>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="view" icon={<ViewDetail />}>
        View Profile
      </Menu.Item>{" "}
      <Menu.Item key="changePassword" icon={<Password />}>
        Change Password
      </Menu.Item>{" "}
      <Menu.Item key="about" icon={<AboutUs />}>
        About Us
      </Menu.Item>{" "}
      <Menu.Item key="terms" icon={<TermsCondition />}>
        Terms & Conditions
      </Menu.Item>
      <Menu.Item key="privacy" icon={<PrivacyPolicy />}>
        Privacy Policies
      </Menu.Item>
      <Menu.Item key="logout" icon={<Logout />} className="logoutBtn">
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Layout style={{ minHeight: "100vh" }} className="customLayout">
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          width={260}
          style={{
            background: "linear-gradient(180deg, #45AE51 0%, #249B6C 100%)",
            position: "fixed",
            height: "100vh",
            left: 0,
            top: 0,
            zIndex: 1000,
          }}
        >
          <div className="sidebarLogo">
            <img
              src={`${process.env.REACT_APP_API_IMG_URI}/${localStorage.getItem(
                "LOGO"
              )}`}
              alt={"logo"}
              height={100}
              width={180}
            />
          </div>
          <Menu
            theme="dark"
            defaultSelectedKeys={["1"]}
            selectedKeys={selectedKeys}
            mode="inline"
            items={items}
            style={{ background: "transparent" }}
            onSelect={handleMenuSelect}
          />
        </Sider>

        <Layout
          style={{
            marginLeft: collapsed ? 80 : 260,
            transition: "margin-left 0.2s",
          }}
        >
          <Header
            style={{
              position: "fixed",
              top: 0,
              left: collapsed ? 80 : 260,
              right: 0,
              zIndex: 999,
              height: 64,
              background: colorBgContainer,
              padding: 0,
              display: "flex",
              alignItems: "center",
              paddingRight: 20,
              paddingLeft: 20,
              transition: "left 0.2s",
            }}
          >
            <div className="headerBx" style={{ width: "100%" }}>
              <p className="headerTitle">{activeMenu?.props?.children}</p>
              {/* <p>{daysLeft === 0 ?  `Your subscription has expired — please renew to continue.` : `Subscription expires in ${daysLeft} days — please renew.`}</p> */}
              { subsData &&  daysLeft <= 30 && (
           <p className={`subscription-message ${daysLeft <= 0 ? 'expired' : 'active'}`}>
            {daysLeft <= 0
              ? 'Your subscription has expired — please renew to continue.'
              : `Subscription expires in ${daysLeft} days — please renew.`}
          </p>
            )}
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
              >
                <div>
                  <Space gap={2}>
                    <Avatar size={40} icon={<UserOutlined />} />
                    <DownOutlined />
                  </Space>
                </div>
              </Dropdown>
            </div>
          </Header>

          <Content
            style={{
              marginTop: 64,
              padding: "30px 50px 50px 30px",
              height: "calc(100vh - 64px)",
              overflowY: "auto",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>

      <ConfirmModal
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={() => {
          logout();
        }}
        actionType={modalConfig.actionType}
      />
      <ChangePasswordModal
        open={changePassword}
        onClose={() => {
          setChangePassword(false);
        }}
        // onConfirm={handleConfirm}
      />
    </>
  );
};
export default DashboardView;
